module.exports = "./dist/assets/images/icons/4a90436d0531e1a523d940416c25af4e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/logout.png
// module id = ./assets/images/icons/logout.png
// module chunks = 0